import {
  Component,
  computed,
  ElementRef,
  EventEmitter,
  inject,
  Inject,
  input,
  Input,
  Output,
  PLATFORM_ID,
  signal,
  ViewChild
} from '@angular/core';
import { isPlatformServer } from "@angular/common";
import {
  Product,
  ProductAttributeInterface,
  ProductCollection,
  ProductVariantInterface
} from "@gea-waldviertler-website/gea-models";
import { ProductService } from "../../services/product.service";

export interface ProductCarouselContentInterface {
  collection: ProductCollection
  attributes: Map<string, ProductAttributeInterface>
}

@Component({
    selector: 'gea-shop-product-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    standalone: false
})
export class SliderComponent {

  contents = input.required<ProductCarouselContentInterface>()
  renderItems = computed<Product<ProductVariantInterface>[]>(() => {
    const c = this.contents()
    let products: Product<ProductVariantInterface>[] = []
    if (! c.collection || (! (c.collection instanceof ProductCollection))) return products
    for (const product of c.collection) {
      products.push(... this.productService.splitByShopAction(product))
    }
    return products
  })

  productService = inject(ProductService)

  @Input() title?: string

  @Output("activePictureChange") setPictureEvent = new EventEmitter<number>()

  /**
   * defining a ViewChild as a setter calls the method when the ElementRef is available
   * this is like an on load listener
   *
   * @param ElementRef<HTMLElement> el
   */
  @ViewChild('scroller', { read: ElementRef }) set ic(el: ElementRef<HTMLDivElement>) {
    if (isPlatformServer(this.platformId) || ! el) return
    const itemEl = el.nativeElement.querySelector('.item')
    if (! itemEl) return
    const clientWidth = itemEl?.clientWidth
    const width = clientWidth ? clientWidth : 100
    let style = window.getComputedStyle(itemEl)
    const marginX = parseInt(style.marginRight) + parseInt(style.marginLeft)
    this.scrollStep = width + marginX
    this.scrollWidth = el.nativeElement.clientWidth
    this.scroller = el
    if (this.contents()) this.totalWidth = this.contents().collection.size * this.scrollStep
    el.nativeElement.addEventListener('scroll', (e) => {
      this.scrollLeft = (e.target as HTMLDivElement).scrollLeft
      this.showNavPrevious.set(this.scrollLeft > 0)
    })

    this.showNavPrevious.set(this.scrollLeft > 0)
    this.showNavNext.set(this.totalWidth > this.scrollWidth && (this.scrollLeft + this.scrollWidth) < this.totalWidth)
  }

  scroller?: ElementRef<HTMLDivElement>

  scrollStep: number = 100
  scrollLeft: number = 0
  scrollWidth: number = 100
  totalWidth: number = 100

  public showNavNext = signal<boolean>(false)
  public showNavPrevious = signal<boolean>(false)

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
  }

  navNext() {
    this.scroller?.nativeElement.scrollBy(this.scrollStep,0)
  }

  navPrev() {
    this.scroller?.nativeElement.scrollBy(-this.scrollStep,0)
  }
}
